var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPmrNightMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,45c-11.03,0-20-8.97-20-20S23.97,5,35,5s20,8.97,20,20-8.97,20-20,20ZM35,6.5c-10.2,0-18.5,8.3-18.5,18.5s8.3,18.5,18.5,18.5,18.5-8.3,18.5-18.5S45.2,6.5,35,6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.54,34.85c-2.58,0-4.68-2.1-4.68-4.68,0-1.75.96-3.31,2.47-4.12v1.9c0,.81.66,1.48,1.47,1.48s1.48-.66,1.48-1.48v-2.42s.07.03.11.03c2.22.41,3.83,2.34,3.83,4.6,0,2.58-2.1,4.68-4.68,4.68M43.58,34.49l-1.48-6.4c-.17-.66-.76-1.12-1.43-1.12h-2.87c-.41-.67-.94-1.25-1.56-1.72v-4.19c0-1.11-1.19-1.8-2.14-1.32l-2.96,1.48c-.5.25-.81.76-.81,1.32v1.89s-.02,0-.03,0c-2.38.93-3.92,3.18-3.92,5.74,0,3.4,2.76,6.16,6.16,6.16s6.29-2.83,6.15-6.41h.83l1.2,5.28c.2.79.99,1.28,1.79,1.08.79-.2,1.27-1,1.08-1.79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,13.67c-1.22,0-2.22,1-2.22,2.22s.99,2.22,2.22,2.22,2.22-1,2.22-2.22-.99-2.22-2.22-2.22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPmrNightMode);
export default __webpack_public_path__ + "static/media/ic_pmr_night_mode.d59d05ee16746483470130d5db05bdf2.svg";
export { ForwardRef as ReactComponent };